import { Package, MapPin, Truck } from "lucide-react";

export const CARRIERS = [["zasilkovna", "Zásilkovna"], ["balikovna", "Balíkovna"]];
const MODES = { zasilkovna: [["zbox", "Z-BOX", 100, Package], ["branch", "Výdejní místo", 100, MapPin], ["address", "Na adresu", 130, Truck]], balikovna: [["branch", "Výdejní místo", 100, MapPin], ["address", "Na adresu", 130, Truck]] };
const FIELDS = [["street", "Ulice a č.p."], ["city", "Město"], ["zip", "PSČ"], ["phone", "Telefon pro dopravce"]];

export const shipPrice = (ship) => (ship.mode === "address" ? 130 : 100);

export const ShippingForm = ({ ship, setShip, billing }) => {
  const pick = (carrier) => setShip({ ...ship, carrier, mode: MODES[carrier].some(([m]) => m === ship.mode) ? ship.mode : "branch" });
  const val = (k) => ship[k] ?? billing[k] ?? "";
  return (
    <div className="mt-6 rounded-[32px] border-2 border-[var(--teal-soft)] p-6 sm:p-8" data-testid="shipping-form">
      <h2 className="text-2xl font-semibold mb-1">Doprava</h2>
      <p className="text-sm text-[var(--muted)] mb-5">V košíku máte tištěný materiál, pošleme vám ho domů nebo na výdejní místo.</p>
      <div className="grid grid-cols-2 gap-3 mb-4">
        {CARRIERS.map(([v, l]) => (
          <button type="button" key={v} onClick={() => pick(v)} data-testid={`shipping-carrier-${v}`} className={`rounded-2xl p-4 font-display text-lg border-2 transition-colors ${ship.carrier === v ? "border-[var(--pink)] bg-[var(--pink-soft)]" : "border-[#f6e3ec] bg-white"}`}>{l}</button>
        ))}
      </div>
      <div className="grid sm:grid-cols-3 gap-2 mb-5">
        {MODES[ship.carrier].map(([v, l, p, I]) => (
          <button type="button" key={v} onClick={() => setShip({ ...ship, mode: v })} data-testid={`shipping-mode-${v}`} className={`flex items-center gap-2 rounded-2xl px-4 py-3 text-sm font-semibold border-2 transition-colors ${ship.mode === v ? "border-[var(--teal)] bg-[var(--teal-soft)]" : "border-[#f6e3ec] bg-white"}`}>
            <I className="w-4 h-4 text-[var(--teal)]" /> {l} <span className="ml-auto font-extrabold">{p} Kč</span>
          </button>
        ))}
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {FIELDS.map(([k, l]) => <input key={k} placeholder={l} value={val(k)} onChange={(e) => setShip({ ...ship, [k]: e.target.value })} className="field" data-testid={`shipping-${k}-input`} />)}
        <input placeholder="Poznámka k doručení (nepovinné)" value={ship.note || ""} onChange={(e) => setShip({ ...ship, note: e.target.value })} className="field sm:col-span-2" data-testid="shipping-note-input" />
      </div>
      <p className="text-xs text-[var(--muted)] mt-4 bg-[var(--sun-soft)] rounded-2xl p-3" data-testid="shipping-info-text">
        {ship.mode === "address" ? "Zásilku doručíme přímo na zadanou adresu." : `Podle zadané adresy vám zásilku pošleme na nejbližší dostupné ${ship.mode === "zbox" ? "Z-BOX" : "výdejní místo"}. Informace o vyzvednutí vám přijde od dopravce.`}
      </p>
    </div>
  );
};
